export default "__VITE_ASSET__C7nm81mO__"